import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/PageHeader";
import HowItWorksButton from "../../../components/howItWorks/HowItWorksButton";
import Constants from "../Constants";

const TAB_IDS = {
  operations: "operations",
  display: "display",
};

const SettingsConstants = ({ token, API }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(TAB_IDS.operations);

  const headerTabs = useMemo(
    () => [
      {
        id: TAB_IDS.operations,
        label: t("settings_constants_tab_operations"),
      },
      {
        id: TAB_IDS.display,
        label: t("settings_constants_tab_display"),
      },
    ],
    [t],
  );

  return (
    <div className="settings-page-wrapper settings-constants-page">
      <PageHeader
        titleContent={<span>{t("My Constants")}</span>}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("Back to Settings")}
        tabs={headerTabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        helpButton={<HowItWorksButton topic="generalSettings" />}
      />
      <div className="settings-content-wrapper">
        <Constants token={token} API={API} activeTab={activeTab} />
      </div>
    </div>
  );
};

export default SettingsConstants;
